import React, { Component }       from 'react';
import { AssistantClaimsCards }   from './AssistantClaimsCards';
import { AssistantClaimsOptions } from './AssistantClaimsOptions';
import AuthService                from 'services/auth.service';
import ClaimsService              from 'services/claims.service';
import queryString                from 'query-string';
import moment                     from 'moment';

const location = AuthService.getPracticeLocation();

class AssistantClaims extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      total_pages: 1,
      per: 10,
      items: [],
      locations: [],
      status: '',
      doctor: '',
      excel_link: '',
      sorting: 'date_desc',
      stats: {
        stats_approved: 0,
        stats_pending_submission: 0,
        stats_pending_approval: 0,
        stats_rejected: 0
      }
    };
  }

  reloadList() {
    const parameters = queryString.stringify({
      page: this.state.page,
      per: this.state.per,
      practice_location_id: location?.id,
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      status: this.state.status,
      doctor: this.state.doctor,
      sorting: this.state.sorting
    });

    ClaimsService.assistantClaims(parameters).then(
      (data) => {
        const meta = data.metadata;

        const stats = {
          stats_approved: meta.approved,
          stats_pending_submission: meta.pending_submission,
          stats_pending_approval: meta.pending_approval,
          stats_rejected: meta.rejected
        }

        this.setState({
          page: meta.current_page,
          total_pages: meta.total_pages,
          stats: stats,
          items: data.claims,
          locations: meta.locations
        });
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  downloadCsv() {
    const parameters = queryString.stringify({
      start_date: this.state.start_date,
      end_date: this.state.end_date,
      status: this.state.status,
      doctor: this.state.doctor
    });

    ClaimsService.downloadCsv(parameters).then(
      (data) => {
        const assistant = AuthService.getCurrentAssistant();
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        const filename = `Claims Export - ${ assistant.email }-${ moment(new Date()).format('YYYY-MM-DD') }.csv`;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      },
      (error) => {
        console.log(error.response);

        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  }
  componentDidMount() {
    const currentPage = queryString.parse(this.props.search);
    const pageNumber  = currentPage.page || 1;
    const startDate   = currentPage.start_date || null;
    const endDate     = currentPage.end_date || null;

    this.setState({
      page: pageNumber,
      start_date: startDate,
      end_date: endDate,
    }, this.reloadList);
  }

  handlePage(previous) {
    var pageNumber = this.state.page;
    const totalPages = this.state.total_pages;

    if (previous) {
      pageNumber = pageNumber === 1 ? 1 : pageNumber - 1;
    } else {
      pageNumber = pageNumber === totalPages ? totalPages : pageNumber + 1;
    }

    this.setState({ page: pageNumber }, this.reloadList);
  }

  updateDateRange(start_date, end_date) {
    let parseStartDate;
    let parseEndDate;

    if (start_date === 'skip') {
      parseStartDate = this.state.start_date;
    } else {
      parseStartDate = start_date ? moment(start_date).format('DD/MM/YYYY') : '';
    }

    if (end_date === 'skip') {
      parseEndDate = this.state.end_date;
    } else {
      parseEndDate = end_date ? moment(end_date).format('DD/MM/YYYY') : '';
    }

    this.setState({
      page: 1,
      start_date: parseStartDate,
      end_date: parseEndDate,
    }, this.reloadList);
  }

  updateFilters(status, doctor, sorting) {
    this.setState({
      page: 1,
      status: status,
      doctor: doctor,
      sorting: sorting
    }, this.reloadList);
  }

  render() {
    return (
      <div id="main-content-target">
        <div className="d-sm-flex justify-content-between align-items-end">
          <h1 className="text-danger mb-4">All Claims</h1>
        </div>

        <div>
          <AssistantClaimsOptions
            page={ this.state.page }
            total_pages={ this.state.total_pages }
            stats={ this.state.stats }
            locations={ this.state.locations }
            prevPage={() => this.handlePage(true) }
            nextPage={() => this.handlePage(false) }
            startDate={ this.state.start_date }
            endDate={ this.state.end_date }
            sorting={ this.state.sorting }
            changeDate={(start_date, end_date) => this.updateDateRange(start_date, end_date) }
            changeFilters={(status, doctor, sorting) => this.updateFilters(status, doctor, sorting) }
            downloadCsv={() => this.downloadCsv() }
          />

          <AssistantClaimsCards items={ this.state.items } handleReload={() => this.reloadList() } />
        </div>
      </div>
    )
  }
}

export default AssistantClaims;